// extracted by mini-css-extract-plugin
module.exports = {"gameBoard":"gameBoard_gameBoard__3IGO8"};